import styled from "styled-components";

export const MenuSell = styled.section`
position:relative;
z-index:15;
position: sticky;
top:0;
background-color: rgb(255,255,255);
`

export const MenuBody = styled.div`
display: flex;
flex-wrap: wrap;
justify-content: space-between;
align-items: center;
min-height: 4.1rem;
`

export const MenuItems = styled.nav`
display: flex;
column-gap: 28px;
text-transform: uppercase;
font-size: 0.75rem;
letter-spacing: 0.1rem;
transition: right 0.5s ease 0s;

@media (max-width:47.94rem) {
   position: fixed;
   top:0px;
   right: ${(props) => (props.menuHiden ? "0" : "120vw")};
   padding: 4rem 0rem 2rem;
   display:block;
   overflow-y: auto;
   font-size: 2rem;
   text-align: center;
   width: 100vw;
   height: 100vh;
   background-color: rgba(255,255,255, 1);
}
`

export const MenuButton = styled.a`
display: inline-block;
   margin: 0.5rem;
   padding: 0.5rem;
   color: rgba(0, 0, 0, 1);
   transition: color 0.3s ease 0s;
   :hover{
      color: rgba(0, 164, 229, 1);
   }
   `

export const MenuUnderline = styled.div`
border-bottom: 1px solid rgba(242, 242, 242, 1);
   `

export const MenuBurgerWrapper = styled.div`
      display: none;
   @media (max-width:47.94rem) {
      display: block;
   }
   `


export const MenuBurgerItem = styled.div`
position: relative;
   width: 40px;
   height: 34px;
`

export const MenuBurgerLine = styled.div`
position: absolute;
left: 0px;
width: 40px;
height: 6px;
border-radius: 3px;
background-color: rgb(0, 0, 0);
`
export const MenuBurgerLine1 = styled(MenuBurgerLine)`
top: 0px;
transition: transform 0.5s ease 0s;
transform: translate(0%, ${(props) => (props.lineRotate ? "0px" : "14px")})
rotate(${(props) => (props.lineRotate ? "0deg" : "45deg")});

`
export const MenuBurgerLine2 = styled(MenuBurgerLine)`
top: 14px;
transition: width 0.5s ease 0s;
width:${(props) => (props.lineRotate ? "40px" : "0px")};

`
export const MenuBurgerLine3 = styled(MenuBurgerLine)`
top: 28px;
transition: transform 0.5s ease 0s;
transform: translate(0%, ${(props) => (props.lineRotate ? "0px" : "-14px")})
rotate(${(props) => (props.lineRotate ? "0deg" : "-45deg")});
`
